(function () {
	"use strict";

	angular.module("qbePortal").controller("QBNgDialog", QBNgDialog);

	QBNgDialog.$inject = [
		"$scope",
		"ngDialog",
		"$timeout",
		"ActivityMonitor",
		"$window",
		"$rootScope",
		"storage",
		"$interval",
		"Util",
	];

	function QBNgDialog(
		$scope,
		ngDialog,
		$timeout,
		ActivityMonitor,
		$window,
		$rootScope,
		storage,
		$interval,
		util
	) {
		var vm = this;

		if ($window.qbe.fieldLabels != undefined) {
			$scope.contentData = $window.qbe.fieldLabels.sessionFunction;
		}

		var timerLengthMinutes =
			$scope.contentData.timerLengthMinutes != undefined
				? $scope.contentData.timerLengthMinutes
				: null;
		var timerLengthSeconds =
			$scope.contentData.timerLengthSeconds != undefined
				? $scope.contentData.timerLengthSeconds
				: null;
		var sessionLengthMinutes =
			$scope.contentData.sessionLengthMinutes != undefined
				? $scope.contentData.sessionLengthMinutes
				: null;
		var sessionLengthSeconds =
			$scope.contentData.sessionLengthSeconds != undefined
				? $scope.contentData.sessionLengthSeconds
				: null;
		var sessionCount =
			$scope.contentData.sessionCount != undefined
				? $scope.contentData.sessionCount
				: null;
		var inactivityTimeMinutes =
			$scope.contentData.inactivityTimeMinutes != undefined
				? $scope.contentData.inactivityTimeMinutes
				: null;
		var inactivityTimeSeconds =
			$scope.contentData.inactivityTimeSeconds != undefined
				? $scope.contentData.inactivityTimeSeconds
				: null;
		var initSession = 0;
		var startTimeOut = null;
		var stopTimeOut = null;
		var continueTimer = true;
		var inactivityTime = null;
		var activeDialog = false;
		var redirectURL = null;
		var timeLeft = null;

		vm.takeoverHeader = $scope.contentData.takeoverHeader;
		vm.takeoverContent = $scope.contentData.takeoverContent;
		vm.yesLabel = $scope.contentData.yesLabel;
		vm.noLabel = $scope.contentData.noLabel;
		vm.redirectURL = $scope.contentData.redirectURL;
		vm.noRedirectURL = $scope.contentData.noRedirectURL;

		activate("init");

		/*
		 * activate - main function to track inactivity and session length
		 * Param - none
		 * Return - none
		 */
		function activate(data) {
			//assign session count depending on storage item set
			var storedSession = storage.getItem("session-count");

			if (data === "init") {
				if (angular.isNumber(storedSession)) {
					initSession = storedSession;
				} else {
					initSession++;
				}
			} else {
				if (angular.isNumber(storedSession)) {
					initSession = storedSession;
				}
				initSession++;
			}

			//store session count in storage
			storage.setItem("session-count", initSession);

			if (!isUndefinedOrNull(inactivityTimeMinutes)) {
				if (isUndefinedOrNull(inactivityTimeSeconds)) {
					inactivityTimeSeconds = 0;
				}

				// compute total idle time
				inactivityTime =
					(inactivityTimeMinutes + inactivityTimeSeconds / 60) * 60;

				// how long (in seconds) until user is considered inactive
				ActivityMonitor.options.inactive = inactivityTime;

				// user is considered inactive, logout etc.
				ActivityMonitor.on("inactive", function () {
					validateSession();
				});
			}

			if (!isUndefinedOrNull(sessionLengthMinutes)) {
				if (isUndefinedOrNull(sessionLengthSeconds)) {
					sessionLengthSeconds = 0;
				}

				//compute total session length on storage
				var storedTime = storage.getItem("time-left");
				if (angular.isNumber(storedTime)) {
					if (storedTime <= 0) {
						timeLeft =
							(sessionLengthMinutes + sessionLengthSeconds / 60) *
							60;
					} else {
						timeLeft = storedTime;
					}
				} else {
					timeLeft =
						(sessionLengthMinutes + sessionLengthSeconds / 60) * 60;
				}

				startTimer();
			}
		}

		/*
		 * startTimer/stopTimer - function to start/stop $timeout function
		 * Param - none
		 * Return -none
		 */
		function startTimer() {
			startTimeOut = $interval(function () {
				timeLeft--;
				if (timeLeft === 0) {
					//$interval.cancel(startTimeout);
					validateSession();
				}
			}, 1000);
		}

		function stopTimer() {
			$interval.cancel(startTimeOut);
		}

		function stopEvents() {
			ActivityMonitor.off("inactive");
			if (startTimeOut) {
				storage.setItem("time-left", timeLeft);
				$interval.cancel(startTimeOut);
			}
		}

		$scope.$on("$destroy", function () {
			stopEvents();
		});

		/*
		 * isUndefinedOrNull - nullity checking
		 * Param - none
		 * Return - boolean
		 */
		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}
			return false;
		}

		/*
		 * dialogCountdown - function to display timer in dialog box
		 * Param - minutes, seconds
		 * Return - none
		 */

		function dialogCountdown(minutes, seconds) {
			var endTime, hours, mins, msLeft, time;

			function twoDigits(n) {
				return n <= 9 ? "0" + n : n;
			}

			function updateTimer() {
				msLeft = endTime - +new Date();
				if (msLeft < 1000) {
					redirectLink(true);
				} else {
					time = new Date(msLeft);
					hours = time.getUTCHours();
					mins = time.getUTCMinutes();
					$scope.timeLeft =
						(hours ? hours + ":" + twoDigits(mins) : mins) +
						":" +
						twoDigits(time.getUTCSeconds());
					angular.element("#timeLeft").html($scope.timeLeft);
					if (continueTimer)
						//stops timer on 'yes' of dialog
						setTimeout(
							updateTimer,
							time.getUTCMilliseconds() + 500
						);
				}
			}

			endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
			updateTimer();
		}

		/*
		 * openDialog - function to display dialog box with yes/no buttons
		 * Param - none
		 * Return - none
		 */
		function openDialog() {
			if (!activeDialog) {
				continueTimer = true;
				activeDialog = true;

				dialogCountdown(timerLengthMinutes, timerLengthSeconds);

				ngDialog
					.openConfirm({
						template: "../ngviews/directives/qbNgDialog.html",
						className: "ngdialog-theme-default",
						scope: $scope,
						closeByDocument: false,
						closeByEscape: false,
						showClose: false,
						disableAnimation: true,
					})
					.then(
						function (value) {
							stopEvents();
							activate("timeout");
							continueTimer = false;
							activeDialog = false;
							console.log("confirm");
						},
						function (reason) {
							activeDialog = false;
							redirectLink(false);
							console.log(
								"Modal promise rejected. Reason: ",
								reason
							);
						}
					);
			} else {
				return;
			}
		}

		/*
		 * validateSession - function to validate session count
		 * Param - none
		 * Return - none
		 */
		function validateSession() {
			if (!isUndefinedOrNull(timeLeft)) {
				stopTimer();
			}

			if (!isUndefinedOrNull(sessionCount)) {
				if (initSession >= sessionCount) {
					redirectLink(true);
				} else {
					openDialog();
				}
			} else {
				openDialog();
			}
		}

		/*
		 * redirectLink - redirect URL
		 * Param - true/false
		 * Return - none
		 */
		function redirectLink(arg) {
			vm.sessionProtPath =
				arg == true ? vm.redirectURL : vm.noRedirectURL;
			$rootScope.$broadcast("session-save-quote");
			// $rootScope.$broadcast("clear-field-values");
			// window.location.href = util.linkBuilder(sessionProtPath);
		}

		$scope.$on("session-redirect", function () {
			console.log("save-successful");
			window.location.href = util.linkBuilder(vm.sessionProtPath);
		});
	}

	angular.module("qbePortal").directive("qbNgDialog", function () {
		return {
			restrict: "A",
			controller: "QBNgDialog",
			controllerAs: "vm",
			scope: {},
			transclude: true,
			link: function ($scope, element, attrs) {
				$scope.timeLeft = null;
				$scope.contentData = {};
			},
		};
	});
})();
